import {
    IDialogShowData,
    ITopicHeaders,
    MessageBroker,
    PostLoginActionNameEnum,
    UiChannel,
} from '@sparkware/uc-sdk-core';
import UserApi from '../../../../APIs/UserApi';
import DialogType from '../../ui/enums/DialogType';
import {
    IPostLoginActionsState,
    IShowPlayerWinLossPostLoginOptions,
} from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';
import Container from 'typedi';
import { WalletService } from '../../wallet';

const MB_HEADER: ITopicHeaders = { publisher: 'ShowPlayerWinLossPostLoginAction' };

export class ShowPlayerWinLossPostLoginAction extends PostLoginActionBase {
    private _uiChannel: UiChannel;
    private readonly _walletService: WalletService;

    constructor(state: IPostLoginActionsState) {
        super(PostLoginActionNameEnum.ShowPlayerWinLoss, 'ShowPlayerWinLossPostLoginAction', state);
        this._uiChannel = MessageBroker.getInstance().ui;
        this._walletService = Container.get(WalletService);
    }
    protected override canExecute = async (
        options?: IShowPlayerWinLossPostLoginOptions,
    ): Promise<boolean> => {
        const canExecute = !options?.isRegistration;

        return canExecute;
    };

    protected override doAction = async (): Promise<boolean> => {
        await this._walletService.sendCurrentUserBalanceUpdated();
        const { response, errorResponse } = await UserApi.GetPlayerWinLoss();

        if (response) {
            const dialogData: IDialogShowData = {
                dialogType: DialogType.ShowPlayerWinLoss,
                options: {
                    apiData: response,
                },
            };

            this._uiChannel.topics.DialogShow.publish(MB_HEADER, dialogData);
        } else {
            this._logger.error(`_internalExecute: ${this.actionName}: error:`, errorResponse);
        }

        this.completeAction();
        return false;
    };
}
